import { forwardRef } from 'react';

import styles from './FloatingIconButton.module.css';

interface FloatingIconButton
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const FloatingIconButton = forwardRef(
  (
    { children, active, ...props }: FloatingIconButton,
    ref: React.Ref<HTMLButtonElement>
  ) => {
    return (
      <button
        {...props}
        data-test-id='floating-icon-btn'
        className={styles.floatingIconBtn}
        data-active={active}
        ref={ref}
      >
        {children}
      </button>
    );
  }
);

FloatingIconButton.displayName = 'FloatingIconButton';
